export const tuesdayUppercase = "F5mJub";
export default {tuesdayUppercase};